import script from "./EntryAuthSend.vue?vue&type=script&setup=true&lang=ts"
export * from "./EntryAuthSend.vue?vue&type=script&setup=true&lang=ts"

import "./EntryAuthSend.vue?vue&type=style&index=0&id=21a12066&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a12066"]])

export default __exports__